import * as contentStatus from '../constants/contentStatus';
import * as requestStatus from '../constants/imagePreloading';
export function isImageLoading(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.PRELOADING;
}
export function isImageIdle(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.IDLE;
}
export function isImageError(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.ERROR;
}
export function isImageLoaded(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.DONE;
}
export function isImageLoadable(screen) {
    return (screen.contentStatus !== contentStatus.IMAGE_UPLOAD_ERROR &&
        screen.contentStatus !== contentStatus.IMAGE_UPLOAD_PENDING);
}
